import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import InputComponent from "../components/InputComponent";
import MyBreakcrumbs from "../components/MyBreadcrumbs";
import { FiMinus, FiPlus } from "react-icons/fi";
import axios from "axios";
import WhatsAppSetingSection from "../components/profile/WhatsAppSetingSection";
import { Formik, Field, ErrorMessage, Form } from "formik";
import { contactInfoValidation } from "../utils/validations/contactInfoValidation";
import { showToast } from "../../clinic/utils/toastUtils";
import {
  serviceGetClinicAddressDetails,
  serviceGetClinicBasicDetails,
  serviceGetClinicContactDetails,
  serviceGetclinicMsgCount,
  serviceUpdateClinicAddressInfo,
  serviceUpdateClinicBasicInfo,
  serviceUpdateClinicContactDetails,
} from "../services/profileApi";

function ClinicProfile() {
  const [emails, setEmails] = useState([""]);
  const [clinicName, setClinicName] = useState("");
  const [primaryEmail, setPrimaryEmail] = useState("");
  const [secondaryEmail, setSecondaryEmail] = useState("");
  const [primaryContact, setPrimaryContact] = useState("");
  const [secondaryContact, setSecondaryContact] = useState("");

  const [showSecondaryEmail, setShowSecondaryEmail] = useState(false);
  const [showSecondaryContact, setShowSecondaryContact] = useState(false);
  const [tertiaryPhoneNumber, setTertiaryPhoneNumber] = useState("");
  const [street1, setStreet1] = useState("");
  const [contacts, setContacts] = useState([""]);
  const [street2, setStreet2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [clinicDetails, setClinicDetails] = useState(null);
  const [msgCounter, setmsgCounter] = useState({});
  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);
  const [contactDetailsShouldSubmit, setContactDetailsShouldSubmit] =
    useState(false); // Initially set to true

  // update Clinic Basic Info
  const updateClinicBasicInfo = async () => {
    const response = await serviceUpdateClinicBasicInfo({
      clinicId: decodedToken.clinic_ids[0],
      clinicName: clinicName === "" ? null : clinicName,
    });

    if (response?.status) {
      showToast(response?.message, "success");
    } else {
      showToast(response?.message, "error");
    }
  };

  // Update Clinic Contact Details
  const updateClinicContactDetails = async (values) => {
    const { primaryEmail, secondaryEmail, primaryContact, secondaryContact } =
      values;

    const response = await serviceUpdateClinicContactDetails({
      clinicId: decodedToken.clinic_ids[0],
      primaryEmail: primaryEmail === "" ? null : primaryEmail,
      secondaryEmail: secondaryEmail === "" ? null : secondaryEmail,
      primaryContact: primaryContact,
      secondaryContact: secondaryContact === "" ? null : secondaryContact,
    });

    if (response?.status) {
      showToast(response?.message, "success");
    } else {
      showToast(response?.message, "error");
    }
  };

  // Update Clinic AddressInfo
  const updateClinicAddressInfo = async () => {
    let params = {
      clinicId: decodedToken.clinic_ids[0],
      street1: street1 === "" ? null : street1,
      street2: street2 === "" ? null : street2,
      city: city === "" ? null : city,
      state: state === "" ? null : state,
      country: country === "" ? null : country,
      pinCode: pinCode === "" ? null : pinCode,
    };
    const response = await serviceUpdateClinicAddressInfo(params);
    if (response?.status) {
      showToast(response?.message, "success");
    } else {
      showToast(response?.message, "error");
    }
  };

  const breadcrumbs = [
    {
      label: "Home",
      href: "#",

      class: "text-[#2E37A4]",
    },
    { label: "Clinic Profile", class: "text-[#2E37A4]" },
  ];

  const [clinic, setClinic] = useState({
    name: "",
    contactNumber: "",
    email: "",
    street1: "",
    street2: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });

  // fetch clinic name
  const fetchClinicBasicDetails = async () => {
    let params = {
      clinicId: decodedToken.clinic_ids[0],
    };
    const response = await serviceGetClinicBasicDetails(params);
    if (response?.status) {
      const { clinicName } = response?.data;
      setClinic({
        name: clinicName,
      });
      setClinicName(clinicName);
      setClinicDetails(response.data);
    }
  };

  // fetch clinic contacts details
  const fetchClinicContactDetails = async () => {
    const response = await serviceGetClinicContactDetails({
      userId: decodedToken.user_id,
    });

    if (response?.status && Object.keys(response?.data)?.length) {
      const { contactInfo } = response?.data;

      const {
        primary_phone_number,
        secondary_phone_number,
        tertiary_phone_number,
        primary_email_id,
        secondary_email_id,
      } = contactInfo;

      // Assuming you have state variables declared for these values
      setPrimaryContact(primary_phone_number);
      setSecondaryContact(secondary_phone_number);
      setTertiaryPhoneNumber(tertiary_phone_number);
      setPrimaryEmail(primary_email_id);
      setSecondaryEmail(secondary_email_id);
      const emails = [primary_email_id];
      const contacts = [primary_phone_number];
  
      if (secondary_email_id) {
        emails.push(secondary_email_id);
        setShowSecondaryEmail(true);
      }
      if (secondary_phone_number) {
        contacts.push(secondary_phone_number);
        setShowSecondaryContact(true);
      }
  
      setEmails(emails);
      setContacts(contacts);
    } else {
      console.error("Error fetching basic information:", response?.message);
    }
  }
  

  // fetch clinic address
  const fetchClinicAddressDetails = async () => {
    const addressDetails = await serviceGetClinicAddressDetails({
      userId: decodedToken.user_id,
    });
    setClinic({
      street1: addressDetails?.street_1,
      street2: addressDetails?.street_2,
      city: addressDetails?.city,
      state: addressDetails?.state,
      country: addressDetails?.country,
      pincode: addressDetails?.pin_code,
    });
    setStreet1(addressDetails?.street_1);
    setStreet2(addressDetails?.street_2);
    setCity(addressDetails?.city);
    setState(addressDetails?.state);
    setCountry(addressDetails?.country);
    setPinCode(addressDetails?.pin_code);
  };

  useEffect(() => {
    fetchClinicBasicDetails();
    getClinicMsgCount();
    fetchClinicContactDetails();
    fetchClinicAddressDetails();
  }, [decodedToken.user_id]); // Added dependency array

  const [collapsedSections, setCollapsedSections] = useState({
    basicInfo: false,
    contactInfo: false,
    addressInfo: false,
    whatsAppInfo: false,
  });

  const toggleSection = (section) => {

    setCollapsedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleRemoveLogin = (index) => {
    const newEmails = [...emails];
    newEmails.splice(index, 1);
    setEmails(newEmails);
     setShowSecondaryEmail(false);
    setSecondaryEmail("");
  };

  const handleAddLogin = () => {
    if (emails.length === 1) {
      setEmails([...emails, ""]);
      setShowSecondaryEmail(true);
    }
  };

  const handleAddloginPhone = () => {
    if (contacts.length === 1) {
      setContacts([...contacts, ""]);
      setShowSecondaryContact(true);
    }
  };

  const handleRemoveLoginPhone = (index) => {
    const newPhones = [...contacts];
    newPhones.splice(index, 1);
    setContacts(newPhones);
    setShowSecondaryContact(false);
    setSecondaryContact("");
  };

  const handlePhoneChange = (index, newValue) => {
    if (index === 0) {
      setPrimaryContact(newValue);
    } else {
      setSecondaryContact(newValue);
    }
  };

  const handleEmailChange = (index, newValue) => {
    if (index === 0) {
      setPrimaryEmail(newValue);
    } else {
      setSecondaryEmail(newValue);
    }
  };

  const getClinicMsgCount = async () => {
    const token = localStorage.getItem("token");
    const decodedToken = jwtDecode(token);
    const clinicId = decodedToken.clinic_ids[0];

    const response = await serviceGetclinicMsgCount({ clinicId });
    if (response?.status) {
      let tempCntr = response?.data?.clinicDetails;
      setmsgCounter(tempCntr);
    }
  };

  return (
    <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6  md:pl-24">
      <div className="pt-2 pb-6">
        <MyBreakcrumbs data={breadcrumbs} />
        <div className=" bg-white   rounded-2xl mt-5">
          <div className="section">
            <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
              <div className=" text-left "> Basic Information</div>
              <button type="button" onClick={() => toggleSection("basicInfo")}>
                {collapsedSections.basicInfo ? <FiPlus /> : <FiMinus />}
              </button>
            </div>
            {!collapsedSections.basicInfo && (
              <div className="section-content px-5 py-12 border-b border-gray-200">
                <div className=" flex flex-row flex-wrap -mx-3 gap-y-6">
                  {/* Clinic Name */}
                  <div className=" w-full lg:w-1/2 px-3">
                    <InputComponent
                      label="Clinic Name"
                      name="name"
                      value={clinicName}
                      type="text"
                      onChange={(e) => setClinicName(e.target.value)}
                    />
                  </div>
                </div>
                <button
                  className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] text-white mt-6"
                  onClick={updateClinicBasicInfo}
                >
                  Update
                </button>
              </div>
            )}
            {/* Contact Information Section */}
            <Formik
              initialValues={{
                primaryEmail: primaryEmail,
                secondaryEmail: secondaryEmail,
                primaryContact: primaryContact,
                secondaryContact: secondaryContact,
              }}
              enableReinitialize={true}
              validationSchema={contactInfoValidation}
              onSubmit={(values, { setSubmitting }) => {
               // if (contactDetailsShouldSubmit) {
                  updateClinicContactDetails(values);
                  setTimeout((values) => {
                    setSubmitting(false);
                  }, 400);
               // }
                //setContactDetailsShouldSubmit(true);
              }}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="section">
                    <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
                      <div className="text-left"> Contact Information</div>
                      <button type="button" onClick={() => toggleSection("contactInfo")}>
                        {collapsedSections.contactInfo ? (
                          <FiPlus />
                        ) : (
                          <FiMinus />
                        )}
                      </button>
                    </div>
                    {!collapsedSections.contactInfo && (
                      <div className="section-content px-5 py-12 border-b border-gray-200">
                        <div className="flex mt-5">
                          {/* Email Update Section */}
                          <div className="flex w-1/2">
                            <div className="flex flex-col w-full">
                              {emails.map((email, index) => (
                                <div key={index} className="flex w-full mb-5">
                                  <div className="w-10/12 px-3">
                                    <InputComponent
                                      label={
                                        index === 0
                                          ? "Primary Email Address"
                                          : "Secondary Email"
                                      }
                                      id={`email-${index}`}
                                      value={
                                        index === 0
                                          ? values.primaryEmail
                                          : values.secondaryEmail
                                      }
                                      type="text"
                                      onChange={(e) =>
                                        setFieldValue(
                                          index === 0
                                            ? "primaryEmail"
                                            : "secondaryEmail",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <div style={{ color: "red" }}>
                                      <ErrorMessage
                                        name={
                                          index === 0
                                            ? "primaryEmail"
                                            : "secondaryEmail"
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="w-2/12 px-3 flex gap-1 pt-5 mt-0.5">
                                    {index === 0 && emails.length < 2 && (
                                      <button
                                        className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0"
                                        onClick={handleAddLogin}
                                      >
                                        <FiPlus />
                                      </button>
                                    )}
                                    {index > 0 && (
                                      <button
                                        className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0"
                                        onClick={() => handleRemoveLogin(index)}
                                      >
                                        <FiMinus />
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Updated Phone Section */}
                          <div className="flex w-1/2">
                            <div className="flex flex-col w-full">
                              {contacts.map((phone, index) => (
                                <div key={index} className="flex w-full mb-5">
                                  <div className="w-10/12 px-3">
                                    <InputComponent
                                      label={
                                        index === 0
                                          ? "Primary Contact Number"
                                          : "Secondary Contact"
                                      }
                                      id={`email-${index}`}
                                      value={
                                        index === 0
                                          ? values.primaryContact
                                          : values.secondaryContact
                                      }
                                      type="text"
                                      onChange={(e) =>
                                        setFieldValue(
                                          index === 0
                                            ? "primaryContact"
                                            : "secondaryContact",
                                          e.target.value
                                        )
                                      }
                                    />
                                    <div style={{ color: "red" }}>
                                      <ErrorMessage
                                        name={
                                          index === 0
                                            ? "primaryContact"
                                            : "secondaryContact"
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="w-2/12 px-3 flex gap-1 pt-5 mt-0.5">
                                    {index === 0 && contacts.length < 2 && (
                                      <button
                                        className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0"
                                        onClick={handleAddloginPhone}
                                      >
                                        <FiPlus />
                                      </button>
                                    )}
                                    {index > 0 && (
                                      <button
                                        className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0"
                                        onClick={() =>
                                          handleRemoveLoginPhone(index)
                                        }
                                      >
                                        <FiMinus />
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <button
                          className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] text-white mt-5"
                          type="submit"
                        >
                          Update
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>

            <div className="section">
              <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
                <div className=" text-left "> Address Information</div>
                <button onClick={() => toggleSection("addressInfo")}>
                  {collapsedSections.addressInfo ? <FiPlus /> : <FiMinus />}
                </button>
              </div>
              {!collapsedSections.addressInfo && (
                <div className="section-content px-5 py-12 border-b border-gray-200">
                  <div className=" flex flex-row flex-wrap -mx-3 gap-y-6">
                    {/* Clinic Address - Street 1 */}
                    <div className=" w-full lg:w-4/12 px-3">
                      <InputComponent
                        label="Street 1"
                        name="street1"
                        value={street1}
                        type="text"
                        onChange={(e) => setStreet1(e.target.value)}
                      />
                    </div>
                    {/* Clinic Address - Street 2 */}
                    <div className=" w-full lg:w-4/12 px-3">
                      <InputComponent
                        label="Street 2"
                        name="street2"
                        value={street2}
                        type="text"
                        onChange={(e) => setStreet2(e.target.value)}
                      />
                    </div>
                    {/* Clinic Address - Pincode */}
                    <div className=" w-full lg:w-4/12 px-3">
                      <InputComponent
                        label="Pincode"
                        name="pincode"
                        value={pinCode}
                        type="text"
                        onChange={(e) => setPinCode(e.target.value)}
                      />
                    </div>
                    {/* Clinic Address - City */}
                    <div className=" w-full lg:w-4/12 px-3">
                      <InputComponent
                        label="City"
                        name="city"
                        value={city}
                        type="text"
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </div>
                    {/* Clinic Address - State */}
                    <div className=" w-full lg:w-4/12 px-3">
                      <InputComponent
                        label="State"
                        name="state"
                        value={state}
                        type="text"
                        onChange={(e) => setState(e.target.value)}
                      />
                    </div>
                    {/* Clinic Address - Country */}
                    <div className=" w-full lg:w-4/12 px-3">
                      <InputComponent
                        label="Country"
                        name="country"
                        value={country}
                        type="text"
                        onChange={(e) => setCountry(e.target.value)}
                      />
                    </div>
                  </div>
                  <button
                    className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] text-white mt-6"
                    onClick={updateClinicAddressInfo}
                  >
                    Update
                  </button>
                </div>
              )}
            </div>
            <WhatsAppSetingSection
              collapsed={collapsedSections.whatsAppInfo}
              toggleSection={toggleSection}
              clinicDetail={clinicDetails}
              msgCounter={msgCounter}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClinicProfile;
